import React from "react";

import styles from "./styles.less";

const Label: React.FC = ({ children }) => (
  <div className={styles.label}>{children}</div>
);

export default Label;
